if ('NodeList' in window && !NodeList.prototype.forEach) {
console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function () {

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });
    $('.badges-slider').slick({
        accessibility: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4
    });

    // table section
    const tablesResp = document.querySelectorAll('.table-js table');
    if (tablesResp.length) {
        tablesResp.forEach((tablei) => {
            let tableresponsive = document.createElement('div')
            tableresponsive.classList.add('tableHold')
            tablei.parentNode.insertBefore(tableresponsive, tablei)
            tableresponsive.append(tablei)
            const ths = tablei.querySelectorAll('tr:first-child > *')
            tablei.querySelectorAll('tr + tr').forEach((row) => {
                const tds = row.querySelectorAll('td')
                let i = 0
                for (i; i < tds.length; i++) {
                    tds[i].setAttribute('data-label', ths[i].textContent)
                }
            })
            const rowHeads = tablei.querySelectorAll('tr td:first-child')
            rowHeads.forEach((ele) => {
                ele.addEventListener('click', (ev) => {
                    ele.closest('tr').classList.toggle('active')
                })
            })
        })
    }

})();

const toggler = document.querySelector(".open-menu");
const togglerMobile = document.querySelector(".burger-menu");
const menuExpand = document.querySelector(".menu-expand");
const OpenClose = document.querySelector(".open-close");
const toggleBookingJs = document.querySelector("#toggle-booking-js");
const bookingBlock = document.querySelector(".booking-block");
const closeBooking = document.querySelector(".booking-block__cta");
const openBooking = document.querySelector(".openBooking");
const wrapperBooking = document.querySelector(".wrapper-booking");
const wrapperSubMenu = document.querySelector(".wrapperSubMenu");
const back = document.querySelector(".back");
const closeBook = document.querySelector(".closeBook");



toggler.addEventListener("click", () => {
    menuExpand.classList.toggle("show");
});
OpenClose.addEventListener("click", () => {
    menuExpand.classList.toggle("show");
});
toggleBookingJs.addEventListener("click", () => {
    bookingBlock.classList.toggle("show");
});
closeBooking.addEventListener("click", () => {
    bookingBlock.classList.toggle("show");
});

openBooking.addEventListener('click', function () {
    wrapperSubMenu.classList.toggle('hide');
    wrapperBooking.classList.toggle('active');
});
// back.addEventListener('click', function () {
//     wrapperSubMenu.classList.toggle('hide');
//     wrapperBooking.classList.toggle('active');
// });
closeBook.addEventListener("click", () => {
    bookingBlock.classList.toggle("show");
    wrapperSubMenu.classList.toggle('hide');
    wrapperBooking.classList.toggle('active');
});
if(togglerMobile){
    togglerMobile.addEventListener("click", () => {
        menuExpand.classList.toggle("show");
    });
}

if (document.querySelectorAll('.select-menu, .select-btn, .option, .sBtn-text').length != 0) {

    const optionMenu = document.querySelector(".select-menu"),
        selectBtn = optionMenu.querySelector(".select-btn"),
        options = optionMenu.querySelectorAll(".option"),
        sBtn_text = optionMenu.querySelector(".sBtn-text");

    selectBtn.addEventListener("click", () =>
        optionMenu.classList.toggle("active")
    );

    options.forEach((option) => {
        option.addEventListener("click", () => {
            let selectedOption = option.querySelector(".option-text").innerText;
            sBtn_text.innerText = selectedOption;

            optionMenu.classList.remove("active");
        });
    });

}

if (document.querySelectorAll('.active-submenu')){
    let tabsCollection = document.querySelectorAll('.active-submenu')
    tabsCollection.forEach( tab => {
        tab.addEventListener('click', () => {
            tab.parentElement.classList.toggle('active');
        })
    })
}